// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-btn[data-v-7c52bb1f]{cursor:pointer;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;display:inline-block;padding:10px 43px;color:#111a37;font-size:14px;line-height:22px;background:#f6f6f6;border-radius:24px;margin:0 auto}.logo-btn .icon[data-v-7c52bb1f]{height:22px;width:22px;vertical-align:top}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
